import APIURL from "../axios";
import { useQuery } from "react-query";

const Flowers = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/flowers`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowFlowers = (uuid, lang) => {
  return useQuery(`flowers-${lang}`, () => Flowers(uuid, lang));
};

const AllFlowers = async (uuid, ph_uuid, lang) => {
  return await APIURL.get(`/${uuid}/flower/${ph_uuid}/categories`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowAllFlowers = (uuid, ph_uuid, lang) => {
  return useQuery(`all_flowers-${lang}-${ph_uuid}`, () =>
    AllFlowers(uuid, ph_uuid, lang)
  );
};

const FlowersSubCatAPI = async (room_uuid, pharmacy_uuid, cat_id, lang) => {
  return await APIURL.get(
    `/${room_uuid}/flower/${pharmacy_uuid}/categories?cat=${cat_id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: lang,
      },
    }
  );
};
export const ShowFlowersSubCatAPI = (uuid, pharmacy_uuid, cat_id, lang) => {
  return useQuery(`FlowersSubCatAPI-${cat_id}`, () =>
    FlowersSubCatAPI(uuid, pharmacy_uuid, cat_id, lang)
  );
};

export const FlowerSubMenuAPI = async ({
  room_uuid,
  Flower_uuid,
  selected,
  pageParam,
  lang,
}) => {
  return await APIURL.get(
    `/${room_uuid}/flower/${Flower_uuid}?cat=${selected}&page=${pageParam}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: lang,
      },
    }
  );
};

// export const ShowFlowerSubMenu = (uuid, ph_uuid, id) => {
//     return useQuery(`flower_sub_menu-${id}`, () => FlowerSubMenu(uuid, ph_uuid, id));
// }

const FlowerItem = async (uuid, f_id, lang) => {
  return await APIURL.get(`/${uuid}/florists/get-item-florist/${f_id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowFlowerItem = (uuid, f_id, lang) => {
  return useQuery(`FlowerItem-${lang}-${f_id}`, () =>
    FlowerItem(uuid, f_id, lang)
  );
};
